<div class="root-body"
     data-testid="comms-feedbacks"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <p-sidebar [(visible)]="visibleFeedbackFilter" position="right" [baseZIndex]="10000">
        <ng-template pTemplate="header">Filter</ng-template>
        <user-feedback-filter [userFeedbackComponent]="this"></user-feedback-filter>
    </p-sidebar>

    <p-sidebar [(visible)]="visibleFeedbackDetail" position="right" [baseZIndex]="10000" [style]="{width:'40em'}">
        <ng-template pTemplate="header">Complaint ID: {{feedbackId}}</ng-template>
        <user-feedback-detail [_feedbackId]="feedbackId" [userFeedbackComponent]="this"></user-feedback-detail>
    </p-sidebar>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <!-- Table -->
    <p-table #xpressUsersGrid
             [columns]="cols"
             [value]="userFeedbacks"
             [lazy]="true"
             responsiveLayout="scroll" dataKey="Id"
             (onLazyLoad)="handleLazyLoad($event)"
             [paginator]="true"
             [(first)]="first"
             [rows]="rowsPerPage"
             [rowsPerPageOptions]="rowsPerPageOptions"
             [totalRecords]="totalRecords"
             [resizableColumns]="true"
             [columnResizeMode]="'expand'"
             [autoLayout]="true"
             [styleClass]="'p-datatable-striped'"
             [scrollable]="true"
             [scrollHeight]="'flex'">
        <ng-template pTemplate="caption">
            <div class="flex justify-content-between">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" class="search-input"
                           [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                           placeholder="Search..." />
                </span>
                <span class="flex title-float-right">
                    <button pButton pRipple type="button" label="Filter" class="p-button-outlined p-button-secondary"
                            (click)="openFeedbackFilter()"></button>

                        <div class="ml-3 mt-1 mr-2 ">
                            <column-selector #columnSelector
                                 [defaultColumns]="defaultCols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="cols">
                            </column-selector>
                        </div>
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of cols"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.disableSort"
                    pResizableColumn
                    [style.width]="col.width">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-userFeedback>
            <tr>
                <td class="ui-resizable-column text-center" *ngFor="let item of cols">
                    {{userFeedback[item.field]}}
                </td>
                <td>
                    <span class="action-icon-svg" (click)="openFeedbackDetail(userFeedback.Id)">
                        <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                    </span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <div *ngIf="userFeedbacks.length > 0" style="padding-left: 10px">
                Displaying {{first + 1}} - {{first + userFeedbacks.length}} of {{totalRecords}}
            </div>
        </ng-template>
    </p-table>
</div>

